import { Flex, Text, useColorModeValue } from '@chakra-ui/react';

type SnapshotWizardStepsProps = {
  current: 'upload' | 'columns' | 'done';
};

export function SnapshotWizardSteps({ current }: SnapshotWizardStepsProps) {
  const active = useColorModeValue('navy.700', 'white');
  const muted = useColorModeValue('gray.400', 'gray.500');

  const stepStyle = (key: 'upload' | 'columns') => ({
    fontWeight: current === key ? '700' : '500',
    color: current === key ? active : muted,
  });

  return (
    <Flex
      gap={3}
      align="center"
      justify="flex-start"
      w="100%"
      mb={6}
      fontSize="sm"
      flexWrap="wrap"
    >
      <Text {...stepStyle('upload')}>Add your list</Text>
      <Text color={muted}>→</Text>
      <Text {...stepStyle('columns')}>Check columns</Text>
      <Text color={muted}>→</Text>
      <Text
        fontWeight={current === 'done' ? '700' : '500'}
        color={current === 'done' ? active : muted}
      >
        See what you share
      </Text>
    </Flex>
  );
}
